var ctrlopt = ctrlopt;

(function ($) {
  var pCounterId, pAppointmentId, pToken,
    loc = window.location,
    nextSection = 'counters',
    apptBook = Drupal.appointmentBooking,
    modelSectionData = [
      {
        id: 'counters',
        jqElem: $('#counters')
      },
      {
        id: 'services',
        jqElem: $('#services')
      },
      {
        id: 'appointments',
        jqElem: $('#appointments')
      },
      {
        id: 'confirmation',
        jqElem: $('#confirmation')
      }

    ];

  function getURLParam(oTarget, sVar) {
    return decodeURI(oTarget.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURI(sVar).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
  }

  pCounterId = getURLParam(loc, 'counter_id');
  pAppointmentId = getURLParam(loc, 'appointment_id');
  pToken = getURLParam(loc, 'token');

  Drupal.behaviors.apptBook = {
    attach: function () {
      var updateObj,
        updateParams = null,
        hasCounters = false,
        hasServices = false,
        container = $('#appointment-book-container'),
        sectionsContainer = $('#appointment-book-sections'),
        sections = sectionsContainer.find('.appt-book-section'),
        sectionManager = apptBook.sectionManager.init(sectionsContainer, sections),
        mData = { data: modelSectionData };

      if (pToken) {
        mData.token = pToken;
      }

      function setCounters(data) {
        if (!data || !data.length) {
          window.location = '/';

          return;
        }
        hasCounters = true;
        if (hasServices) {
          run();
        }
      }

      function setServices() {
        hasServices = true;
        if (hasCounters) {
          run();
        }
      }

      function run() {
        var currentSection, $header, $tabs, $title, $subhead, isMobile;

        sectionManager.setModel(apptBook.sectionModel).startObserving();
        apptBook.historyHandler.setModel(apptBook.sectionModel).startObserving();

        if (pCounterId) {
          nextSection = 'services';
          updateParams = {
            sectionId: nextSection,
            counterId: pCounterId
          };
        }

        if (pAppointmentId) {
          nextSection = 'appointments';
          updateParams = {
            appointmentId: pAppointmentId
          };
        }

        updateObj = {
          sectionId: nextSection,
          params: updateParams
        };

        // Subscribe to sectionModel update events and update the page header and the page indication tabs
        apptBook.sectionModel.on('update', function (data) {
          var config = Drupal.settings.appointment_booking_main_collection,
            section = data.sectionId;

          if (section === currentSection) {
            return;
          }

          $header = $('.appt-book-page-header');
          $tabs = $('.appt-book-page-header-content__tabs', $header);
          $title = $('.appt-book-page-header-content__title', $header);
          $subhead = $('.appt-book-page-header-content__subhead', $header);
          $content = $('.appt-book-page-header-content', $header);
          $image = $('.appt-book-page-header-bg', $header);
          isMobile = Unison.fetch.now().name === 'small';
          // isMobile = site.client.isMobile;

          if (isMobile) {
            $title = $('span', $title);
          }

          var s = {};

          for (var key in config) {
            if (!config.hasOwnProperty(key)) {
              continue;
            }

            s = config[key];
            if (s['section_key'] == section) {
              break;
            }
          }

          if (!$.isEmptyObject(s)) {
            if (s['section_key'] == 'confirmation') {
              $tabs.hide();
            } else {
              $tabs.show();
            }

            var i = s['section_number'];

            if (i.length > 0) {
              $('li', $tabs)
                .removeClass('active')
                .filter('.tab--' + i)
                .addClass('active');
            } else {
              $('li', $tabs).removeClass('active');
            }

            $title.html(s['section_title']);
            $subhead.html(s['section_subhead']);
            $content.css('height', $image.css('height'));
          }

          currentSection = section;
        });

        apptBook.sectionModel.update(updateObj);
      }

      apptBook.sectionModel.on('data_set', function () {
        apptBook.sectionModel.off('data_set');
        apptBook.sectionModel.getCounters(setCounters);
        apptBook.sectionModel.getServices(setServices);
      });

      apptBook.sectionModel.setData(mData);
    }
  };
})(jQuery);
